import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import List from "@mui/material/List";
import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import {
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Input,
} from "reactstrap";
import DeleteModal from './DeleteModal';

export default function History() {
  const [arrivals, setArrivals] = useState([]);
  const [filteredArrivals, setFilteredArrivals] = useState();
  const [departures, setDepartures] = useState([]);
  const [filteredDepartures, setFilteredDepartures] = useState();
  const [openStates, setOpenStates] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [searchValue2, setSearchValue2] = useState('');
  const [change, setChange] = useState(false);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState();
  const [uid, setUid] = useState();
  const [placeIdInfo, setPlaceIdInfo] = useState();
  const [dateInfo, setDateInfo] = useState();
  const [registrationNumberInfo, setRegistrationNumberInfo] = useState();
  const [containerNumberInfo, setContainerNumberInfo] = useState();

  const handleToggle = (id) => {
    setOpenStates((prevOpenStates) => ({
      ...prevOpenStates,
      [id]: !prevOpenStates[id],
    }));
  };

  const getArrivalsAndDepartures = async() => {
    const docRef = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
    const docRef2 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);

    if (response.exists() && response2.exists()) {
      setArrivals(response.data().arrivalHistory.sort((a, b) => new Date(b.date) - new Date(a.date)));
      setDepartures(response2.data().departuresHistory.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };

  useEffect(() => {
    getArrivalsAndDepartures();
  }, []);

  const handleOpenModal = (action, uid, placeId, date, containerNumber, registrationNumber) => {
    setAction(action);
    setUid(uid);
    setPlaceIdInfo(placeId);
    setDateInfo(date);
    setContainerNumberInfo(containerNumber);
    setRegistrationNumberInfo(registrationNumber);
    setOpen(true);
  }

  const filteredArrivalsFunc = () => {
        if (arrivals) {
          const found = arrivals.filter((arrival) => {
            const containerNumber = arrival.containerNumber.toLowerCase();
    
            return (
                containerNumber.includes(searchValue.toLowerCase())
            );
          });
          setFilteredArrivals(found.sort((a, b) => new Date(b.date) - new Date(a.date)));
        }
  }

  const filteredDeparturesFunc = () => {
    if (departures) {
        const found = departures.filter((departure) => {
          const containerNumber = departure.containerNumber.toLowerCase();
  
          return (
              containerNumber.includes(searchValue2.toLowerCase())
          );
        });
        setFilteredDepartures(found.sort((a, b) => new Date(b.date) - new Date(a.date)));
      }
  }

  const search = document.querySelector("#search");

  if (search)
    search.addEventListener("keyup", (e) => {
      // Sprawdź, czy naciśnięty klawisz to "Enter" (keyCode 13)
      if (e.keyCode === 13) {
        // Tutaj umieść kod, który ma zostać wykonany po naciśnięciu klawisza "Enter"
        filteredArrivalsFunc();
      }
    });

  const search2 = document.querySelector("#search2");

  if (search2)
    search2.addEventListener("keyup", (e) => {
      // Sprawdź, czy naciśnięty klawisz to "Enter" (keyCode 13)
      if (e.keyCode === 13) {
        // Tutaj umieść kod, który ma zostać wykonany po naciśnięciu klawisza "Enter"
        filteredDeparturesFunc();
      }
    });

  return (
    <>      
    <DeleteModal setChange={setChange} change={change} action={action} open={open} uid={uid} setOpen={setOpen} placeIdInfo={placeIdInfo} dateInfo={dateInfo} registrationNumberInfo={registrationNumberInfo} containerNumberInfo={containerNumberInfo} />

    <div className="history-container">
    <div className="history-box">
    <h3>Arrivals</h3>
    <div className="box">
      <InputGroup className="no-border">
              <Input
                onChange={(e) => {
                  e.preventDefault();
                  setSearchValue(e.target.value);
                }}
                id="search"
                placeholder="Search by container number"
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={() => filteredArrivalsFunc()}
                  style={{ backgroundColor: "white", cursor: "pointer" }}
                >
                  <i
                    style={{ color: "rgb(255, 193, 7)" }}
                    className="nc-icon nc-zoom-split"
                  />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
            {filteredArrivals
  ? filteredArrivals.map((arrival) => {
      return (
        <div key={arrival.uid}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "center",
              flexFlow: "row nowrap",
            }}
          >
            <p style={{ marginBottom: 0, margin: "5px" }}>
              {arrival.date} - {arrival.containerNumber}
            </p>
            {openStates[`ID${arrival.uid}`] ? (
              <ExpandLess onClick={() => handleToggle(`ID${arrival.uid}`)} />
            ) : (
              <ExpandMore onClick={() => handleToggle(`ID${arrival.uid}`)} />
            )}
          </div>
          <Collapse
            in={openStates[`ID${arrival.uid}`]}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Status: </strong>
                    {arrival.status}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Place: </strong>
                    {arrival.place}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Date: </strong>
                    {arrival.date}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Registration number: </strong>
                    {arrival.registrationNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Container number: </strong>
                    {arrival.containerNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <button className="btn" onClick={() => handleOpenModal('arrival', arrival.uid, arrival.place, arrival.date, arrival.containerNumber, arrival.registrationNumber) }>Delete</button>
                  </span>
                }
              />
            </List>
          </Collapse>
        </div>
      );
    })
  : arrivals
  ? arrivals.map((arrival) => {
      return (
        <div key={arrival.uid}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "center",
              flexFlow: "row nowrap",
            }}
          >
            <p style={{ marginBottom: 0, margin: "5px" }}>
              {arrival.date} - {arrival.containerNumber}
            </p>
            {openStates[`ID${arrival.uid}`] ? (
              <ExpandLess onClick={() => handleToggle(`ID${arrival.uid}`)} />
            ) : (
              <ExpandMore onClick={() => handleToggle(`ID${arrival.uid}`)} />
            )}
          </div>
          <Collapse
            in={openStates[`ID${arrival.uid}`]}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
            <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Status: </strong>
                    {arrival.status}
                  </span>
                }
              />
            <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Place: </strong>
                    {arrival.place}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Date: </strong>
                    {arrival.date}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Registration number: </strong>
                    {arrival.registrationNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Container number: </strong>
                    {arrival.containerNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <button className="btn" onClick={() =>  handleOpenModal('arrival', arrival.uid, arrival.place, arrival.date, arrival.containerNumber, arrival.registrationNumber) }>Delete</button>
                  </span>
                }
              />
            </List>
          </Collapse>
        </div>
      );
    })
  : ""}
        </div>
        </div>
        <div className="history-box">
        <h3>Departures</h3>
        <div className="box">
        <InputGroup className="no-border">
              <Input
                onChange={(e) => {
                  e.preventDefault();
                  setSearchValue2(e.target.value);
                }}
                id="search2"
                placeholder="Search by container number"
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={() => filteredDeparturesFunc()}
                  style={{ backgroundColor: "white", cursor: "pointer" }}
                >
                  <i
                    style={{ color: "rgb(255, 193, 7)" }}
                    className="nc-icon nc-zoom-split"
                  />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
            {filteredDepartures
  ? filteredDepartures.map((departure) => {
      return (
        <div key={departure.uid}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "center",
              flexFlow: "row nowrap",
            }}
          >
            <p style={{ marginBottom: 0, margin: "5px" }}>
              {departure.date} - {departure.containerNumber}
            </p>
            {openStates[`ID${departure.uid}`] ? (
              <ExpandLess onClick={() => handleToggle(`ID${departure.uid}`)} />
            ) : (
              <ExpandMore onClick={() => handleToggle(`ID${departure.uid}`)} />
            )}
          </div>
          <Collapse
            in={openStates[`ID${departure.uid}`]}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Status: </strong>
                    {departure.status}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Date: </strong>
                    {departure.date}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Registration number: </strong>
                    {departure.registrationNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Container number: </strong>
                    {departure.containerNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <button className="btn" onClick={() => handleOpenModal('departure', departure.uid, departure.date, departure.containerNumber, departure.registrationNumber) }>Delete</button>
                  </span>
                }
              />
            </List>
          </Collapse>
        </div>
      );
    })
  : departures
  ? departures.map((departure) => {
      return (
        <div key={departure.uid}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "center",
              flexFlow: "row nowrap",
            }}
          >
            <p style={{ marginBottom: 0, margin: "5px" }}>
              {departure.date} - {departure.containerNumber}
            </p>
            {openStates[`ID${departure.uid}`] ? (
              <ExpandLess onClick={() => handleToggle(`ID${departure.uid}`)} />
            ) : (
              <ExpandMore onClick={() => handleToggle(`ID${departure.uid}`)} />
            )}
          </div>
          <Collapse
            in={openStates[`ID${departure.uid}`]}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Status: </strong>
                    {departure.status}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Date: </strong>
                    {departure.date}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Registration number: </strong>
                    {departure.registrationNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <strong>Container number: </strong>
                    {departure.containerNumber}
                  </span>
                }
              />
              <ListItemText
                style={{ marginLeft: "1rem" }}
                primary={
                  <span className="listItem">
                    <button className="btn" onClick={() => handleOpenModal('departure', departure.uid, departure.date, departure.containerNumber, departure.registrationNumber) }>Delete</button>
                  </span>
                }
              />
            </List>
          </Collapse>
        </div>
      );
    })
  : ""}
        </div>
        </div>
    </div>
    </>
  );
}
